/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import './spectrum-analyzer.scss';

import 'javascript-detect-element-resize/detect-element-resize';
import $ from 'jquery';

/* eslint-disable angular/angularelement */
/*@ngInject*/
export default function SpectrumAnalyzerController($rootScope, $q, $document, $scope, $mdDialog, $timeout, $mdUtil, $translate,
                                                   toast, types, gatewayCommandService, gatewayId) {

    var vm = this;

    vm.$onInit = function () {
        vm.gatewayId = gatewayId;
        vm.types = types;

        vm.spectrumAnalyzer = {
            samplePeriod: 0,
            sampleCount: 1,
            startFrequencykHz: 902300,
            stopFrequencykHz: 914100,
            binSpacingkHz: 200
        };

        vm.antenna = types.spectrumAnalyzerAntenna.antenna0.value;
        vm.samplePeriod = (vm.spectrumAnalyzer.samplePeriod + 1) * 0.5;

        vm.spectrumAnalyzerExecuting = false;
        vm.spectrumAnalyzerTimeout = null;
        vm.spectrumAnalyzerNotSupported = false;

        var font = {
            color: "#545454",
            size: 10,
            family: "Roboto"
        };

        vm.plotOptions = {
            title: null,
            subtitle: null,
            shadowSize: 4,
            HtmlText: false,
            grid: {
                hoverable: false,
                borderWidth: 2,
                color: "#DDDDDD",
                tickColor: "#DDDDDD"
            },
            legend: {
                show: false
            },
            xaxis: {
                font: angular.copy(font),
                labelFont: {family: font.family, color: font.color, size: font.size + 2, weight: 'bold'}
            },
            yaxis: {
                font: angular.copy(font),
                labelFont: {family: font.family, color: font.color, size: font.size + 2, weight: 'bold'}
            },
            colors: []
        };

        vm.plotData = {
            'antennaSpectrum': null
        };

        vm.currentPlotDataKey = null;

        vm.plotMinimum = -140;
        vm.plotMaximum = 0;

        vm.maxDbfs2dbm = 0;
        vm.minDbfs2dbm = 0;

        vm.plot = null;
        vm.showPlot = false;

        vm.antennasCount = 2;

        vm.samplePeriodChanged = function () {
            vm.spectrumAnalyzer.samplePeriod = Math.floor(vm.samplePeriod / 0.5) - 1;
        };

        vm.plotMinMaxChanged = function () {
            updatePlotYMinMax();
            updatePlot();
        };

        vm.spectrumAnalyzerAntenna = function (antennasCount) {
            var antennas = {};
            for (var i = 0; i < antennasCount; i++) {
                var antennaName = "antenna" + i;
                antennas[antennaName] = vm.types.spectrumAnalyzerAntenna[antennaName];
            }
            if (antennasCount > 1) {
                antennas.both = vm.types.spectrumAnalyzerAntenna.both;
            }
            return antennas;
        };

        vm.startSpectrumAnalyzer = startSpectrumAnalyzer;
        vm.stopSpectrumAnalyzer = stopSpectrumAnalyzer;
        vm.close = close;

        vm.loading = function () {
            return $rootScope.loading;
        };

        loadSpectrumAnalyzerParams();
    };

    function close() {
        if (vm.showPlot) {
            var parent = angular.element('#tk-spectrum-analyzer-dialog', $document);
            removeResizeListener(parent[0], updatePlot); //eslint-disable-line
        }
        stopSpectrumAnalyzer();
        $mdDialog.cancel();
    }

    function loadSpectrumAnalyzerParams() {
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.gatewayCommand.getAntennasCount.value, {}, true).then(
            (params) => {
                if (params.error) {
                    if (!angular.equals(params.error, types.gatewayCommandNotSupported.value)) {
                        onError(params.error);
                    }
                } else {
                    vm.antennasCount = params.antennasCount;
                }
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function startSpectrumAnalyzer() {
        vm.spectrumAnalyzerExecuting = true;
        prepareAntennaSpectrumOptions();
        vm.currentPlotDataKey = 'antennaSpectrum';
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.spectrumAnalyzerCommand.setSpectrumAnalyzerParams.value, vm.spectrumAnalyzer, true).then(
            () => {
                vm.maxDbfs2dbm = 0;
                vm.minDbfs2dbm = 0;
                getAntennasSpectrumAnalyzerOutput();
            },
            (rejection) => {
                onError(rejection.data);
            }
        );
    }

    function stopSpectrumAnalyzer() {
        vm.spectrumAnalyzerExecuting = false;
        if (vm.spectrumAnalyzerTimeout) {
            $timeout.cancel(vm.spectrumAnalyzerTimeout);
            vm.spectrumAnalyzerTimeout = null;
        }
    }

    function getAntennasSpectrumAnalyzerOutput() {
        vm.spectrumAnalyzerTimeout = $timeout(() => {
            if (vm.antenna == types.spectrumAnalyzerAntenna.both.value) {
                getAntennaSpectrumAnalyzerOutput(0).then(
                    (data) => {
                        var antenna1Data = data;
                        if (!vm.spectrumAnalyzerExecuting) {
                            return;
                        }
                        getAntennaSpectrumAnalyzerOutput(1).then(
                            (data) => {
                                var antenna2Data = data;
                                onAntennaSpectrumData(antenna1Data, antenna2Data);
                                if (vm.spectrumAnalyzerExecuting) {
                                    getAntennasSpectrumAnalyzerOutput();
                                }
                            },
                            () => {
                                onSpectrumAnalyzerStopped();
                            }
                        );
                    },
                    () => {
                        onSpectrumAnalyzerStopped();
                    }
                );
            } else {
                var antenna = vm.antenna == types.spectrumAnalyzerAntenna.antenna0.value ? 0 : 1;
                getAntennaSpectrumAnalyzerOutput(antenna).then(
                    (data) => {
                        onAntennaSpectrumData(data);
                        if (vm.spectrumAnalyzerExecuting) {
                            getAntennasSpectrumAnalyzerOutput();
                        }
                    },
                    () => {
                        onSpectrumAnalyzerStopped();
                    }
                );
            }
        }, 300);
    }

    function getAntennaSpectrumAnalyzerOutput(antenna) {
        var deferred = $q.defer();
        gatewayCommandService.executeCommand(vm.gatewayId.id,
            types.spectrumAnalyzerCommand.getSpectrumAnalyzerOutput.value, {antenna: antenna}, true).then(
            (data) => {
                if (data.error) {
                    vm.spectrumAnalyzerNotSupported = true;
                    if (angular.equals(data.error, types.gatewayCommandNotSupported.value)) {
                        onError($translate.instant("gateway-command.not-supported"));
                    } else {
                        onError(data.error);
                    }
                } else {
                    deferred.resolve(data);
                }
            },
            (rejection) => {
                onError(rejection.data);
                deferred.reject();
            }
        );
        return deferred.promise;
    }

    function onSpectrumAnalyzerStopped() {

    }

    function onError(error) {
        vm.spectrumAnalyzerExecuting = false;
        var toastParent = angular.element('#tk-spectrum-analyzer-dialog', $document);
        var dialogContent = toastParent.find('md-dialog-content');
        if (dialogContent.length > 0) {
            toastParent = dialogContent;
        }
        toast.showError(error, toastParent, 'bottom right');
    }

    function prepareAntennaSpectrumOptions() {
        vm.plotOptions.xaxis.min = vm.spectrumAnalyzer.startFrequencykHz;
        vm.plotOptions.xaxis.max = vm.spectrumAnalyzer.stopFrequencykHz;
        vm.plotOptions.xaxis.tickFormatter = frequencyTickFormatter;
        vm.plotOptions.xaxis.ticks = ticksFunction;
        vm.plotOptions.xaxis.label = $translate.instant('spectrum-analyzer.spectrum-plot-frequency-title');
        vm.plotOptions.yaxis.tickFormatter = powerTickFormatter;
        vm.plotOptions.yaxis.ticks = ticksFunction;
        vm.plotOptions.yaxis.label = $translate.instant('spectrum-analyzer.spectrum-plot-power-title');
        if (vm.antenna == types.spectrumAnalyzerAntenna.both.value) {
            vm.plotOptions.colors = ['rgb(76, 175, 80)', 'rgb(229, 57, 53)'];
            vm.plotOptions.legend.show = true;
            vm.plotOptions.legend.noColumns = 2;
        } else {
            vm.plotOptions.colors = ['rgb(33, 150, 243)'];
            vm.plotOptions.legend.show = false;
        }
    }

    function frequencyTickFormatter(value) {
        return (value / 1000).toFixed(1);
    }

    function powerTickFormatter(value) {
        return value.toFixed(1);
    }

    function ticksFunction(axis) {
        var step = (axis.max - axis.min) / 4;
        var ticks = [];
        for (var i=0;i<5;i++) {
            ticks.push(axis.min + step * i);
        }
        return ticks;
    }

    function onAntennaSpectrumData(antenna1Data, antenna2Data) {
        vm.plotData['antennaSpectrum'] = prepareAntennaSpectrumData(antenna1Data, antenna2Data);
        updatePlotYMinMax();
        updatePlot();
    }

    function prepareAntennaSpectrumData(antenna1Data, antenna2Data) {
        var spectrumData = [];
        if (vm.antenna == types.spectrumAnalyzerAntenna.both.value) {
            spectrumData.push(createAntennaSpectrumDataSet($translate.instant('spectrum-analyzer.antenna0')+'', antenna1Data));
            spectrumData.push(createAntennaSpectrumDataSet($translate.instant('spectrum-analyzer.antenna1')+'', antenna2Data));
        } else {
            spectrumData.push(createAntennaSpectrumDataSet($translate.instant('spectrum-analyzer.antenna0')+'', antenna1Data));
        }
        return spectrumData;
    }

    function createAntennaSpectrumDataSet(label, antennaData) {
        var data = [];
        var dbfs2dbm = antennaData.dbm2dbfsOffset;
        vm.maxDbfs2dbm = Math.max(vm.maxDbfs2dbm, dbfs2dbm);
        if (!vm.minDbfs2dbm) {
            vm.minDbfs2dbm = dbfs2dbm;
        } else {
            vm.minDbfs2dbm = Math.min(vm.minDbfs2dbm, dbfs2dbm);
        }
        for (var i=0;i<antennaData.data.length;i++) {
            var x = vm.spectrumAnalyzer.startFrequencykHz + vm.spectrumAnalyzer.binSpacingkHz * i;
            var y = -(antennaData.data[i]+dbfs2dbm);
            var point = [x,y];
            data.push(point);
        }
        return {label: label, data: data};
    }

    function updatePlotYMinMax() {
        if (vm.plotMaximum) {
            vm.plotOptions.yaxis.min = vm.plotMinimum;
            vm.plotOptions.yaxis.max = vm.plotMaximum;
        } else {
            vm.plotOptions.yaxis.min = -(100 + vm.maxDbfs2dbm);
            vm.plotOptions.yaxis.max = -(60 + vm.minDbfs2dbm);
        }
    }

    function updatePlot() {
        if (!vm.currentPlotDataKey || !vm.plotData[vm.currentPlotDataKey]) {
            return;
        }
        if (vm.showPlot) {
            vm.plot = $.plot(vm.spectrumFlotElement, vm.plotData[vm.currentPlotDataKey], vm.plotOptions);
        } else {
            var parent = angular.element('#tk-spectrum-analyzer-dialog', $document);
            vm.spectrumFlotElement = parent.find('#spectrum-flot');
            vm.showPlot = true;
            addResizeListener(parent[0], updatePlot); //eslint-disable-line
            $mdUtil.nextTick(() => {
                vm.plot = $.plot(vm.spectrumFlotElement, vm.plotData[vm.currentPlotDataKey], vm.plotOptions);
            });
        }
    }


}
/* eslint-enable angular/angularelement */


// WEBPACK FOOTER //
// ./src/app/gateway/spectrum-analyzer/spectrum-analyzer.controller.js